// src/layouts/MainLayout.tsx
import { AppSidebar } from "@/components/app-sidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { DocumentHeadUpdater } from "@/components/DocumentHeadUpdater";

export const MainLayout = () => {
    const location = useLocation();
    
    // Only apply full-screen treatment to specific Activepieces embed routes
    const isActivepiecesEmbedRoute = location.pathname.match(
        /^\/dashboard\/workflows\/(flows|runs|connections|tables|todos)/
    );
    
    // Use stable key for workflows routes to prevent double mounting during sub-route changes
    const getRouteKey = () => {
        if (location.pathname.startsWith('/dashboard/workflows')) {
            return '/dashboard/workflows'; // Stable key for all workflows sub-routes
        }
        return location.pathname; // Normal behavior for other routes
    };
    
    return (
        <SidebarProvider defaultOpen={true}>
            <DocumentHeadUpdater />
            <AppSidebar />
            <SidebarInset className={isActivepiecesEmbedRoute ? "flex flex-col" : ""}>
                <div className={`flex flex-col h-full ${
                    isActivepiecesEmbedRoute ? "" : ""
                }`}>
                    <AnimatePresence mode="wait" initial={false}>
                        <Outlet key={getRouteKey()} /> {/* Stable key for workflows, dynamic for others */}
                    </AnimatePresence>
                </div>
            </SidebarInset>
        </SidebarProvider>
    );
};

// Export both named and default
export default MainLayout;